import styled from "styled-components";

export const Body = styled.div`
  overflow-x: hidden;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 80px;
  background: white;
  min-height: 100vh;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const ContentWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 24px;
`;

export const IconContainer = styled.div`
  margin-bottom: 40px;
`;

export const DoneIcon = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
`;

export const Message = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #000;
  margin: 0;
  text-align: center;
`;
